var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.valueIsDefined)?_c('translated-entity-badge',{attrs:{"value":_vm.params.value,"values":_vm.params.values,"invalid":_vm.params.invalid}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }